import { Component, Input, OnInit } from "@angular/core";
import { DashboardMultiStationService } from "../dashboard-multistation.service";
import { Router } from "@angular/router";

@Component({
	selector: "caass-ms-waiting-for-verification",
	templateUrl: "./ms-waiting-for-verification.component.html",
	styleUrls: ["./ms-waiting-for-verification.component.css"],
})
export class MsWaitingForVerificationComponent implements OnInit {
	constructor(private visitorService: DashboardMultiStationService, private router: Router) {}

	ngOnInit(): void {
		this.loadData();
	}

	ngOnChanges() {
		this.loadData();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() FacilityID: number;

	Inited: boolean = false;

	OptionID: number = 0;
	Title: string = "Facility";

	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;

	SelectedVisitorPass: any;
	lstVisitorPass: any = [];
	lstDestination: any = [];
	lstVisitorReasonDesc: any = [];

	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "Destination", header: "Destination" },
		{ field: "VisitorReasonDesc", header: "Reason" },
		{ field: "Comment", header: "Notes" },
	];

	ImageDict: Map<number, string> = new Map(); //Dictionary that matches Visitor Pass IDs to base64 of image
	lstImageCalls: any = [];

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadData() {
		if (this.FacilityID == undefined) {
			return;
		}

		this.loading = true;

		var result = this.visitorService.WaitingForVerificationInfoSelectList(this.OptionID == 0 ? this.FacilityID : -1);
		result.subscribe(
			(response: any) => {
				this.lstVisitorPass = response;

				for (var z = 0; z < this.lstVisitorPass.length; z++) {
					var next = this.lstVisitorPass[z];

					next.RouterLink = "/multistation/verifyvisitor/" + next.VisitorPassID;
				}

				this.lstDestination = Array.from(new Set(this.lstVisitorPass.map((item: any) => item.Destination))).sort();
				this.lstVisitorReasonDesc = Array.from(new Set(this.lstVisitorPass.map((item: any) => item.VisitorReasonDesc))).sort();

				if (this.Inited == false) {
					this.Inited = true;
				}

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onRowSelect(val) {
		this.SelectedVisitorPass = val.data;
	}
	onRowUnselect(val) {
		this.SelectedVisitorPass = null;
	}
	onRowDblClick(VisitorPass) {
		this.SelectedVisitorPass = VisitorPass;

		document.getElementById("Link" + VisitorPass.VisitorPassID).click();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	SelectOption(opt) {
		this.OptionID = opt;

		if (this.OptionID == 0) {
			this.Title = "Facility";
		} else if (this.OptionID == 1) {
			this.Title = "District";
		}

		this.loadData();
	}

	GetPhotoData(VisitorPassID) {
		if (this.ImageDict.has(VisitorPassID)) {
			return this.ImageDict.get(VisitorPassID);
		} else {
			var found = false;

			for (var z = 0; z < this.lstImageCalls.length; z++) {
				var next = this.lstImageCalls[z];

				if (next == VisitorPassID) {
					found = true;
					break;
				}
			}

			if (found) {
				return "assets\\images\\loading.gif";
				//return this.ImageDict.get(-1); //Already made the webservice call
			} else {
				//Make the webservice call 1 time
				this.lstImageCalls = [...this.lstImageCalls, VisitorPassID]; //Add to list of calls made

				var result = this.visitorService.GetPhotoByVisitorPass(VisitorPassID);
				result.subscribe(
					(response: any) => {
						this.ImageDict.set(VisitorPassID, response.VisitorPhoto);

						return response.VisitorPhoto;
					},
					(error) => {
						return this.ImageDict.get(-1); //Missing Photo
					}
				);
			}
		}
	}

	////////////////////////////////////////////
}
